import React from "react";
import { Banner } from "@/ds";
import { useT } from "../i18n";
import { useSession } from "../session";
import type { PushToast } from "@/notifications/toast-queue";
import { RuleValuesEditor } from "./screen-tenant-rule-parameters";
import { businessRuleValuesAdapter } from "./rule-values-adapter";

export function BusinessRuleValuesEditor({ tenantId, enabled, pushToast }: {
  tenantId: string; enabled: boolean; pushToast: PushToast;
}) {
  const t = useT();
  const { user } = useSession();
  // The API checks role, tenant and capability again on every read, preview and save.
  if (!user || !["admin", "owner"].includes(user.role) || user.tenantId !== tenantId) return null;
  if (!enabled) return <Banner tone="info" title={t("ruleValues.unavailable.title")}>
    {t("ruleValues.unavailable.body")}
  </Banner>;
  return <RuleValuesEditor key={`${user.id}:${tenantId}`} tenantId={tenantId}
    adapter={businessRuleValuesAdapter} pushToast={pushToast} />;
}
